<template>
  <div class="view3">
    <van-nav-bar title="个人中心" style="background: #2d9eea !important" />
    <div class="topBg" style="background-image: url(image/bg.jpg);" >
     <center>
        <div class="icons" style="background-image: url(image/tx.png);"></div>
        <br>
        <font class="msgs" >{{uname}}</font>
      </center>
    </div>
    <div class="mars">
      <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="goAno('changePwd')">
        <div class="van-cell__title"><span>修改密码</span></div>
        <i class="van-icon van-icon-arrow van-cell__right-icon"><!----></i>
      </div>
    </div>
    <center>
      <van-button round type="info" block style="width:80vw;margin-top:50px" @click="loginOut()">退出登录</van-button>
    </center>
  </div>
</template>
<script>
import _URL from "../../lib/url";
import { Toast, Dialog } from "vant";
import { getAction, postAction } from "@/api/manage";
export default {
  name: "sign",
  components: {},
  data: function () {
    return {
      active: "home",
      uname:localStorage.getItem('realname'),
    };
  },
  mounted: function () {
    
  },
  methods: {
    goAno(val){
      this.$router.push({path:val});
    },
    test() {
      alert(1);
    },
    loginOut(){
        localStorage.setItem('act','home');
      localStorage.removeItem('t');
      location.reload();
    },
    goAno(val){
      this.$router.push({path:val});
    },
    changeImg(){
      Toast('演示期间暂未提供头像修改功能');
    },
    ksjl(){
     
    },
  },
};
</script>
<style lang="less">
.view3 {
  .topBg {
    height: 50vw;
    background-size: cover;
    border-top: solid 1px #2d9eea;
  }
  .icons {
    height: 90px;
    width: 90px;
    border: solid 3px #67b9f0;
    background: white;
    margin: 30px auto;
    border-radius: 50%;
    background-size: cover;
  }
  .msgs {
    color: white;
    position: relative;
    top:-30px;
  }
  .mars {
    margin: 12px 12px 0;
    overflow: hidden;
    border-radius: 8px;
  }
  .van-cell__right-icon {
    font-size: 16px !important;
  }
}
</style>